/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";

// authentication
import { withAxios } from "containers/authenticated.js";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
// Removed Card components in favor of simple divs
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import Button from "components/CustomButtons/Button.jsx";
import PlanDetailsCard from "components/Plan/PlanDetailsCard.jsx";

import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import DescriptionIcon from "@material-ui/icons/Description";
import EditIcon from "@material-ui/icons/Edit";
import TrainingsPlanner from "views/TrainingsPlanner/TrainingsPlanner.jsx";

import {
  getMyUsers,
  getUserPlans,
  getUserPlanDetails,
  updateUserPlan,
  refreshUserTrainingPlan
} from "../../services/advisorUsers.js";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

const ADVICES = ["DIETARY", "FORMULA", "ROUTINE", "EXERCISE"];
const sortPlansByEndTimeDesc = (a, b) =>
  new Date(b.end_time) - new Date(a.end_time);

class Plan extends React.Component {
  state = {
    users: []
  };

  getRouteUserId = () => {
    const routeUserId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.user_id;
    const parsedUserId = parseInt(routeUserId, 10);
    return Number.isNaN(parsedUserId) ? null : parsedUserId;
  };

  componentDidMount() {
    const urlUserId = this.getRouteUserId();
    if (urlUserId) {
      // If user_id is in URL, automatically load that user's plans
      this.setState({ userId: urlUserId }, () => {
        getUserPlans(this.props.axios, urlUserId).then(data => {
          const recommData = data && data.sort(sortPlansByEndTimeDesc)[0];
          recommData && this.separateHealthAdvices(recommData);
          recommData &&
            this.setState({ userPlans: data, adviceData: recommData });
        });
      });
    } else {
      // Otherwise, load all users for selection
      getMyUsers(this.props.axios).then(data => {
        this.setState({
          users: data
        });
      });
    }
  }

  componentDidUpdate(prevProps) {
    const previousRouteUserId =
      prevProps.match &&
      prevProps.match.params &&
      prevProps.match.params.user_id;
    const currentRouteUserId = this.getRouteUserId();

    if (
      String(previousRouteUserId || "") === String(currentRouteUserId || "")
    ) {
      return;
    }

    if (!currentRouteUserId) {
      return;
    }

    this.setState(
      {
        userId: currentRouteUserId,
        userPlans: [],
        adviceData: null,
        planDetails: null,
        selectedPlanId: null
      },
      () => {
        getUserPlans(this.props.axios, currentRouteUserId).then(data => {
          const recommData = data && data.sort(sortPlansByEndTimeDesc)[0];
          recommData && this.separateHealthAdvices(recommData);
          recommData &&
            this.setState({ userPlans: data, adviceData: recommData });
        });
      }
    );
  }

  separateHealthAdvices(adviceData) {
    let existingAdvices = adviceData.health_advices || {};
    let healthAdvices = {};
    existingAdvices.forEach(thisAdvice => {
      if (thisAdvice.name) {
        healthAdvices[thisAdvice.name] = thisAdvice.details || [];
      }
    });
    ADVICES.forEach(adviceName => {
      if (healthAdvices[adviceName] === undefined) {
        healthAdvices[adviceName] = [];
      }
    });
    this.setState({ healthAdvices: healthAdvices });
  }

  handleUserChange = value => {
    this.setState(
      {
        userId: value,
        adviceData: {}
      },
      () => {
        getUserPlans(this.props.axios, value).then(data => {
          const recommData = data && data.sort(sortPlansByEndTimeDesc)[0];
          recommData && this.separateHealthAdvices(recommData);
          recommData &&
            this.setState({ userPlans: data, adviceData: recommData });
        });
      }
    );
  };

  handlePlanChange = planId => {
    const selectedPlan = this.state.userPlans.find(plan => plan.id === planId);
    if (selectedPlan) {
      this.setState(
        {
          selectedPlanId: planId,
          adviceData: selectedPlan,
          newStartDate: selectedPlan.start_time,
          newEndDate: selectedPlan.end_time,
          showDateEditor: false
        },
        () => {
          // make api call to get plan details if needed
          getUserPlanDetails(this.props.axios, this.state.userId, planId).then(
            data => {
              this.setState({ planDetails: data });
            }
          );
        }
      );
      this.separateHealthAdvices(selectedPlan);
    }
  };

  toggleDateEditor = () => {
    const { adviceData } = this.state;
    this.setState(prevState => ({
      showDateEditor: !prevState.showDateEditor,
      newStartDate: adviceData.start_time,
      newEndDate: adviceData.end_time
    }));
  };

  handleDateChange = field => event => {
    this.setState({ [field]: event.target.value });
  };

  handleUpdatePlan = async () => {
    const { adviceData, newStartDate, newEndDate, userId } = this.state;
    this.setState({ updatingPlan: true });

    try {
      const updatedPlanData = {
        ...adviceData,
        start_time: newStartDate,
        end_time: newEndDate
      };

      await updateUserPlan(
        this.props.axios,
        userId,
        adviceData.id,
        updatedPlanData
      );

      // Refresh the plan data
      const updatedPlans = await getUserPlans(this.props.axios, userId);
      const updatedSelectedPlan = updatedPlans.find(
        plan => plan.id === adviceData.id
      );

      this.setState({
        userPlans: updatedPlans,
        adviceData: updatedSelectedPlan,
        showDateEditor: false,
        updatingPlan: false
      });

      if (updatedSelectedPlan) {
        this.separateHealthAdvices(updatedSelectedPlan);
      }
    } catch (error) {
      this.setState({ updatingPlan: false });
      // eslint-disable-next-line no-alert
      alert("Failed to update plan dates");
    }
  };

  handleChange = (name, inputType) => event => {
    let value = null;
    let currentState = this.state.adviceData || {};
    if (inputType === "checkbox") {
      value = event.target.checked;
    } else {
      value = event.target.value;
    }

    currentState[[name]] = value;
    this.setState({ adviceData: currentState });
  };

  onFileLoad = e => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      this.setState({ planCsv: file });
    }
  };

  handleSubmit = recommId => () => {
    const healthAdvices = this.state.healthAdvices || {};
    let healthAdvicesData = Object.keys(healthAdvices).map(adviceName => {
      return {
        name: adviceName,
        details: healthAdvices[adviceName]
      };
    });
    let adviceData = this.state.adviceData;
    adviceData["health_advices"] = healthAdvicesData;
    updateUserPlan(
      this.props.axios,
      this.state.userId,
      recommId,
      adviceData,
      this.state.planCsv
    ).then(data => {
      this.separateHealthAdvices(data);
      this.setState({ adviceData: data });
    });
  };

  handleRefreshCalculations = async () => {
    const userId = this.state.userId || this.getRouteUserId();
    if (!userId) {
      return;
    }

    this.setState({ refreshingCalculations: true });
    try {
      await refreshUserTrainingPlan(this.props.axios, userId);
      const updatedPlans = await getUserPlans(this.props.axios, userId);
      const selectedPlanId = this.state.selectedPlanId;
      const refreshedSelectedPlan =
        updatedPlans.find(plan => plan.id === selectedPlanId) ||
        updatedPlans.sort(sortPlansByEndTimeDesc)[0];

      this.setState({
        userPlans: updatedPlans,
        adviceData: refreshedSelectedPlan || this.state.adviceData,
        refreshingCalculations: false
      });

      if (refreshedSelectedPlan) {
        this.separateHealthAdvices(refreshedSelectedPlan);
        if (selectedPlanId) {
          const planDetails = await getUserPlanDetails(
            this.props.axios,
            userId,
            selectedPlanId
          );
          this.setState({ planDetails });
        }
      }
    } catch (error) {
      this.setState({ refreshingCalculations: false });
      // eslint-disable-next-line no-alert
      alert("Failed to refresh calculations");
    }
  };

  handleAdviceChange = (adviceName, idx, fieldName) => event => {
    // console.log("handleAdviceChange", adviceName, idx, fieldName);
    let healthAdvices = this.state.healthAdvices;
    let healthAdvice = healthAdvices[adviceName];
    healthAdvice[idx][fieldName] = event.target.value;
    healthAdvices[adviceName] = healthAdvice;
    this.setState({ healthAdvices: healthAdvices });
  };

  addAdvice = adviceName => () => {
    let healthAdvices = this.state.healthAdvices;
    let healthAdvice = healthAdvices[adviceName];
    healthAdvice.push({
      name: "",
      description: ""
    });
    healthAdvices[adviceName] = healthAdvice;
    this.setState({ healthAdvices: healthAdvices });
  };

  removeAdvice = (adviceName, idx) => () => {
    let healthAdvices = this.state.healthAdvices;
    let healthAdvice = healthAdvices[adviceName].filter(
      (_ad, aId) => aId !== idx
    );
    healthAdvices[adviceName] = healthAdvice;
    this.setState({ healthAdvices: healthAdvices });
  };

  renderPlanDetails() {
    const { adviceData, planDetails, refreshingCalculations } = this.state;

    if (!adviceData) {
      return (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div>
              <p>Please select a user and a plan to view details.</p>
            </div>
          </GridItem>
        </GridContainer>
      );
    }

    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "12px"
          }}
        >
          <Button
            color="info"
            onClick={this.handleRefreshCalculations}
            disabled={refreshingCalculations}
          >
            {refreshingCalculations ? "Refreshing..." : "Refresh Calculations"}
          </Button>
        </div>
        <PlanDetailsCard
          recommendationData={adviceData}
          planDetails={planDetails}
        />
      </div>
    );
  }

  renderUpdatePlan() {
    const { selectedPlanId, userId } = this.state;

    if (!selectedPlanId) {
      return (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div>
              <p>Please select a user and a plan to view details.</p>
            </div>
          </GridItem>
        </GridContainer>
      );
    }

    const plannerLocation = {
      ...(this.props.location || {}),
      state: {
        ...((this.props.location && this.props.location.state) || {}),
        actor: userId
      }
    };

    return (
      <TrainingsPlanner
        key={`planner-${userId || "none"}-${selectedPlanId || "none"}`}
        axios={this.props.axios}
        hideHeader
        hideUserSelection
        mergeWithContainer
        location={plannerLocation}
      />
    );
  }

  renderUsersSelectionBox() {
    // Don't render user selection if user_id is in URL
    const urlUserId = this.getRouteUserId();
    if (urlUserId) {
      return null;
    }

    let userOptions =
      this.state.users &&
      this.state.users.map(user => {
        return { text: user.username, value: user.id };
      });
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <CustomSelect
            labelText={"User"}
            items={userOptions}
            onChange={this.handleUserChange}
          />
        </GridItem>
      </GridContainer>
    );
  }

  renderPlanSelector() {
    const { userPlans, selectedPlanId } = this.state;

    if (!userPlans || userPlans.length === 0) {
      return null;
    }

    const planOptions = userPlans.map(plan => {
      const endDate = new Date(plan.end_time);
      const now = new Date();
      const isPast = endDate < now;

      return {
        value: plan.id,
        text: `${plan.recommendation_type} (${plan.start_time} to ${
          plan.end_time
        })${isPast ? " - PAST" : ""}`
      };
    });

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <CustomSelect
            labelText="Select Plan"
            items={planOptions}
            value={selectedPlanId}
            onChange={this.handlePlanChange}
          />
        </GridItem>
      </GridContainer>
    );
  }

  renderHealthAdviceForm(adviceName, data, idx) {
    return (
      <GridContainer key={`advice-${idx}`}>
        <GridItem xs={11} sm={3} md={3}>
          <CustomInput
            // success={inputState["details"] === "success"}
            // error={inputState["details"] === "error"}
            labelText={
              <span>
                {"Name"}
                <small>(required)</small>
              </span>
            }
            id={`input-name-${idx}-${adviceName}`}
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              value: data && data.name,
              onChange: this.handleAdviceChange(adviceName, idx, "name")
            }}
          />
        </GridItem>
        <GridItem xs={11} sm={8} md={8}>
          <CustomInput
            // success={inputState["details"] === "success"}
            // error={inputState["details"] === "error"}
            labelText={
              <span>
                {"Details"}
                <small>(required)</small>
              </span>
            }
            id={`input-details-${idx}-${adviceName}`}
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              value: data && data.description,
              onChange: this.handleAdviceChange(adviceName, idx, "description")
            }}
          />
        </GridItem>
        <GridItem xs={1} sm={1} md={1}>
          <CloseIcon onClick={this.removeAdvice(adviceName, idx)} />
        </GridItem>
      </GridContainer>
    );
  }

  renderAdviceBlock(adviceName, adviceData) {
    // console.log("renderAdviceBlock", adviceName, adviceData);
    return (
      <div>
        <h6>{adviceName}</h6>
        {adviceData.map((data, idx) => {
          // console.log("renderAdviceBlock", adviceName, idx, data);
          return this.renderHealthAdviceForm(adviceName, data, idx);
        })}
        <AddIcon onClick={this.addAdvice(adviceName)} />
      </div>
    );
  }

  renderTabbedView() {
    const { selectedPlanId } = this.state;

    if (!selectedPlanId) {
      return (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div>
              <p>Please select a user and a plan to view details.</p>
            </div>
          </GridItem>
        </GridContainer>
      );
    }

    return (
      <CustomTabs
        headerColor="info"
        tabs={[
          {
            tabName: "Plan Details",
            tabIcon: DescriptionIcon,
            tabContent: this.renderPlanDetails()
          },
          {
            tabName: "Update Plan",
            tabIcon: EditIcon,
            tabContent: this.renderUpdatePlan()
          }
        ]}
      />
    );
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { classes } = this.props;
    return (
      <div>
        {this.renderUsersSelectionBox()}
        {this.renderPlanSelector()}
        {this.renderTabbedView()}
      </div>
    );
  }
}

Plan.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withAxios(withStyles(dashboardStyle)(Plan));
